export enum ORDER_STATUS {
    PICK = 'PICK',
    PACK = 'PACK',
    READY_TO_COMPLETE = 'READY_TO_COMPLETE',
    COMPLETE = 'COMPLETE'
}